<ui-organism-title-logos/>
<ui-organism-main-nav [mainText]="pageTitle" />

<ui-atom-spacer />
<!-- <ui-atom-text type="medium" [text]="'beneficiaries.list.subtitle' | translate"></ui-atom-text> -->
<ui-atom-spacer size="spacer-xxl" />

<!-- Tabs con Beneficiaries y Users -->
<div class="beneficiaries-tabs">
  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedIndexChange)="onTabChange($event)"
    class="beneficiaries-tabs__group"
  >
    <!-- Tab Beneficiaries -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'beneficiariesTabs.beneficiaries' | translate }}
      </ng-template>
      <div class="beneficiaries-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'beneficiaries.list.actions.goTo' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onGlobalSearch($event)" />
        <section class="beneficiaries-list-table">
          <ui-molecule-mat-table
            [data]="tableData"
            [columns]="tableColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [isLoading]="isLoading"
            [actions]="tableActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'beneficiaries'"
            [useExportColumnPicker]="true"
            (actionClick)="onTableAction($event)"
            (rowClick)="onTableRowClick($event)"
            (pageChange)="onTablePageChange($event)"
            (sortChange)="onTableSortChange($event)"
            (exportAllDataWithColumns)="onExportAllBeneficiaries($event)"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              [withShadow]="true"
              [text]="'beneficiaries.list.actions.create' | translate"
              (click)="goToCreate()"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>

    <!-- Tab Forms -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'beneficiariesTabs.forms' | translate }}
      </ng-template>
      <div class="beneficiaries-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'beneficiariesForms.subtitle' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onFormsGlobalSearch($event)" />
        <section class="forms-list-table">
          <ui-molecule-mat-table
            [data]="formsData"
            [columns]="formsColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="formsTotalItems"
            [pageIndex]="formsPageIndex"
            [pageSize]="formsPageSize"
            [isLoading]="isLoadingForms"
            [actions]="formsActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'forms'"
            [useExportColumnPicker]="true"
            (actionClick)="onFormAction($event)"
            (rowClick)="onFormRowClick($event)"
            (pageChange)="onFormPageChange($event)"
            (sortChange)="onFormSortChange($event)"
            (filterChange)="onFormFilterChange($event)"
            (exportAllDataWithColumns)="onExportAllForms($event)"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              [withShadow]="true"
              (buttonClick)="openCreateFormDialog()"
              [text]="'beneficiariesForms.create' | translate"
              icon="add"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>

    <!-- Tab Users -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'beneficiariesTabs.users' | translate }}
      </ng-template>
      <div class="beneficiaries-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'beneficiariesUsers.subtitle' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onUserGlobalSearch($event)" />
        <section id="users-table" class="users-list-table">
          <ui-molecule-mat-table
            [data]="usersData"
            [columns]="userColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="userTotalItems"
            [pageIndex]="userPageIndex"
            [pageSize]="userPageSize"
            [isLoading]="isLoadingUsers"
            [actions]="userActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'users'"
            (actionClick)="onUserAction($event)"
            (pageChange)="onUserPageChange($event)"
            (sortChange)="onUserSortChange($event)"
            (exportAllData)="onExportAllUsers()"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              (click)="openCreateUserDialog()"
              [text]="'beneficiariesUsers.create' | translate"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
